import { LevelCard } from '../level_card/LevelCard';
import { buildLevelCardsForPage } from './levelCardsData';

export type LevelCardsProps = {
  page?: number;
  successfulDeliveries: number;
  averageRating: number;
};

/** Level cards column from Figma 162:24017 — five tiers per arrow page. */
export function LevelCards({
  page = 0,
  successfulDeliveries,
  averageRating,
}: LevelCardsProps) {
  const cards = buildLevelCardsForPage(page, successfulDeliveries, averageRating);

  return (
    <>
      {cards.map((card) => (
        <LevelCard
          key={card.key}
          top={card.top}
          title={card.title}
          description={card.description}
          achieved={card.achieved}
          isCurrent={card.isCurrent}
        />
      ))}
    </>
  );
}
